import BasedHeader from "../components/BasedHeader";

export default function BasedHome() {
  return (
    <>
      <BasedHeader />
      <div className="min-h-screen bg-gradient-radial from-gray-900 via-black to-black text-white pt-32 px-4">

        {/* Top Image Fan Effect - Mobile Friendly */}
        <div className="relative max-w-7xl mx-auto flex flex-wrap justify-center items-center gap-4 md:gap-8 mb-24 px-4 md:px-8">
          <img 
            src="https://basedponks.xyz/ponkimages/158.webp" 
            alt="Ponk 1" 
            className="w-32 md:w-48 h-auto transform -rotate-12 opacity-80 hover:opacity-100 transition-all duration-500 hover:rotate-0 hover:scale-110"
          />
          <img 
            src="https://basedponks.xyz/ponkimages/1342.webp" 
            alt="Ponk 2" 
            className="w-40 md:w-56 h-auto transform scale-105 opacity-90 hover:opacity-100 transition-all duration-500 hover:scale-125"
          />
          <img 
            src="https://basedponks.xyz/ponkimages/2333.webp" 
            alt="Ponk 3" 
            className="w-32 md:w-48 h-auto transform rotate-12 opacity-80 hover:opacity-100 transition-all duration-500 hover:rotate-0 hover:scale-110"
          />
        </div>

        {/* Welcome Section */}
        <section className="max-w-5xl mx-auto text-center mb-24 px-4">
          <h1 className="text-3xl md:text-5xl font-bold mb-6 text-gradient-based">
            Welcome to Based Ponks
          </h1>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
            The first 3D Punks on Base. Revolutionizing digital art with unique design and community-driven values.
          </p>
        </section>

        {/* About Section */}
        <section className="max-w-5xl mx-auto grid grid-cols-1 gap-8 md:gap-16 px-4">
          <AboutCard 
            icon="🎯" 
            title="Our Mission" 
            text="Based Ponks is redefining the NFT space by introducing unique 3D artistry on the Base blockchain, combined with real utility. All royalties go back to holders—every NFT sale incurs a 12% fee, where 8% remains as Base ETH and 4% is used to buy $WEEP. Holders can claim rewards every month or simply hold onto their Ponks to increase their value on the secondary market."
          />
        </section>

        {/* Collaboration Section */}
        <section className="max-w-5xl mx-auto text-center mt-32 px-4">
          <h2 className="text-2xl md:text-4xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600">
            🎭 In Collaboration with Weeping Plebs
          </h2>
          <p className="text-gray-400 text-base md:text-lg mb-8">
            We’re proud to collaborate with <span className="text-purple-400">Weeping Plebs</span>, bringing our unique art to their game.
          </p>

          <div className="flex flex-col items-center">
            <img
              src="https://basedponks.xyz/ponkimages/plebs.jpg"
              alt="Weeping Plebs Logo"
              className="w-64 md:w-80 h-auto rounded-xl shadow-lg hover:shadow-purple-500/50 transition"
            />
            <a
              href="https://x.com/WeepingPlebs"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-block bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold py-3 px-6 md:px-8 rounded-xl hover:opacity-90 transition"
            >
              Follow Weeping Plebs on X
            </a>
          </div>
        </section>

      </div>
    </>
  );
}

/* Reusable About Section Card */
const AboutCard = ({ icon, title, text }: { icon: string; title: string; text: string }) => (
  <div className="glass rounded-2xl p-6 md:p-8 transform transition-all hover:-translate-y-2 hover:shadow-xl hover:shadow-blue-500/10">
    <div className="text-blue-400 text-3xl md:text-4xl mb-4">{icon}</div>
    <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gradient-based">{title}</h2>
    <p className="text-gray-400 leading-relaxed text-sm md:text-base">{text}</p>
  </div>
);
